import { render } from "./Example1.vue?vue&type=template&id=8c85ced2&ts=true"
import script from "./Example1.vue?vue&type=script&lang=ts"
export * from "./Example1.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__